<template>
  <div class="animated fadeIn">
    <b-row>
      <!-- CITY INFORMATION DATA OVERVIEW -->
      <b-col lg="8" offset="2">
        <b-card class="information" header="data">
          <div slot="header">
            <h5 style="display: inline;" class="card-title mb-0">
              Information
            </h5>
          </div>
          <div style="min-height: 403px">
            <span class="title-details">
              Company :
              <b>{{ cityData.company }}</b>
            </span>
            <span class="title-details">
              Location :
              <b>{{ cityData.location }}</b>
            </span>
            <span class="title-details">
              Contact :
              <b>{{ cityData.contact }}</b>
            </span>

            <span class="title-details">
              Address :
              <b>{{ cityData.address1 }}, {{ cityData.clientZip }}</b>
            </span>
            <span class="title-details">
              Phone :
              <b>{{ cityData.clientPhone }}</b>
            </span>
            <span class="title-details">
              Email :
              <b>{{ cityData.clientEmail }}</b>
            </span>
            <div v-show="loadingCity" class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>

            <gmap-map
              v-if="!loadingMap"
              :center="center"
              :options="mapOptions"
              style="width:100%;  height: 160px;margin-top:25px"
            >
              <gmap-marker
                :key="key"
                v-for="(item, key) in center"
                :position="getPosition(item)"
              ></gmap-marker>
            </gmap-map>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!--SECOND ROW  -->
    <b-row>
      <ActiveBacklog
        v-if="propsReady"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="locationParam"
        :nameCity="cityParam"
      ></ActiveBacklog>
      <shipped
        v-if="propsReady"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="locationParam"
        :nameCity="cityParam"
      ></shipped>
    </b-row>
    <b-row>
      <HistoricalData
        v-if="propsReady"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="locationParam"
        :nameCity="cityParam"
      ></HistoricalData>
      <BER
        v-if="propsReady"
        :lgSize="6"
        :lgOffset="0"
        :locParam="0"
        :idCity="locationParam"
        :nameCity="cityParam"
      ></BER>

      <!--<NTF-->
      <!--v-if="propsReady"-->
      <!--:lgSize="6"-->
      <!--:lgOffset="0"-->
      <!--:locParam="0"-->
      <!--:idCity="locationParam"-->
      <!--:nameCity="cityParam"-->
      <!--&gt;</NTF>-->
    </b-row>
    <!-- <b-row>
      <delivery
        v-if="propsReady"
        :lgSize="12"
        :lgOffset="0"
        :locParam="0"
        :idCity="locationParam"
        :nameCity="cityParam"
      ></delivery>
    </b-row> -->
    <!--/.row-->
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import ActiveBacklog from "../../components/ActiveBacklog-Column-City";
import BER from "../../components/BER-Column-City";
import HistoricalData from "../../components/CITY-HistoricalData-Stacked";
// import NTF from "../../components/NTF-Column";
import shipped from "../../components/ShippedByFNS-Column-City";
// import delivery from "../../components/Delivery";

export default {
  name: "dashboard",
  props: ["loc", "city", "lat", "lng"],
  components: {
    ActiveBacklog,
    HistoricalData,
    BER,
    // NTF,
    shipped,
    //delivery,
    highcharts: Chart
  },
  data: function() {
    return {
      propsReady: false,
      locationParam: "",
      cityData: [],
      cityParam: "",
      mapOptions: {
        zoom: 7,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        draggable: false
      },
      center: { lat: null, lng: null },
      loadingMap: true
    };
  },

  methods: {
    fetchCityData() {
      let params = {};
      params = {
        client: this.locationParam
      };
      this.$http
        .get("api/profile/clientInfo.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            this.cityData = res.data;
            this.loadingCity = false;
          },
          err => {
            console.log(err);
          }
        );
    },

    getPosition: function(marker) {
      return {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng)
      };
    }
  },

  mounted() {
    if (!localStorage.getItem("aoi_user")) {
      router.push("/pages/login/");
    }
    this.locationParam = this.loc;
    this.cityParam = this.city;

    this.center.lat = parseFloat(this.lat);
    this.center.lng = parseFloat(this.lng);
    this.loadingMap = false;
    this.fetchCityData();

    this.propsReady = true;
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
</style>
